"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RequestError = void 0;
const headers_1 = require("./headers");
class RequestError {
    constructor(message) {
        this.message = message;
    }
    write(protocol) {
        if (this.message !== undefined) {
            protocol.writeModelPropertyHeader(new headers_1.ModelPropertyHeader('message', 'string'));
            protocol.writeStringValue(this.message);
        }
    }
    read(protocol, modelHeader) {
        for (let a = 0; a < modelHeader.propertyCount; a++) {
            const propertyHeader = protocol.readModelPropertyHeader();
            if (!this.readProperty(protocol, propertyHeader))
                throw new Error(`Property ${propertyHeader.propertyName} not recognized`);
        }
    }
    readProperty(protocol, propertyHeader) {
        switch (propertyHeader.propertyName) {
            case 'message':
                if (propertyHeader.type !== 'string')
                    throw new Error(`Unexpected data type for property message (${propertyHeader.type})`);
                this.message = protocol.readStringValue();
                return true;
            default:
                return false;
        }
    }
    slipstreamWrite(writer) {
        writer.writeStringValue(this.message || 'Undefined');
    }
    slipstreamRead(reader) {
        this.message = reader.readStringValue();
    }
    toError() {
        return new Error(this.message);
    }
}
exports.RequestError = RequestError;
